import { spacing } from './spacing'

export interface ComponentStyles {
  integratedBenefitsExplorer: {
    showHeader: boolean
    showMinimizedBannerDesign: boolean
    showBenefitsAndCoverageSection: boolean
    showEmbeddedCenterOfExcellenceEntrypoint: boolean
  }
  integratedBenefitsEntryCard: {
    showBorder: boolean
    paddingHorizontal: string
    divider: {
      height: string
    }
    shouldShowArrow: boolean
    allowBackgroundColorOverride: boolean
    showEmbeddedCenterOfExcellenceEntrypoint: boolean
  }
  compactImageCard: {
    useBodyText: boolean
    shouldShowChevron: boolean
    borderRadius: string
    showBorder: boolean
  }
  navBar: {
    useSmallBackButton: boolean
  }
  useFloatingCardsShadows: boolean
}

export const defaultComponentStyles: ComponentStyles = {
  integratedBenefitsExplorer: {
    showHeader: false,
    showMinimizedBannerDesign: true,
    showBenefitsAndCoverageSection: false,
    showEmbeddedCenterOfExcellenceEntrypoint: true,
  },
  integratedBenefitsEntryCard: {
    showBorder: true,
    paddingHorizontal: spacing['24px'],
    divider: {
      height: '2px',
    },
    shouldShowArrow: true,
    allowBackgroundColorOverride: true,
    showEmbeddedCenterOfExcellenceEntrypoint: true,
  },
  compactImageCard: {
    useBodyText: true,
    shouldShowChevron: true,
    borderRadius: spacing['16px'],
    showBorder: true,
  },
  navBar: {
    useSmallBackButton: true,
  },
  useFloatingCardsShadows: true,
}
